import React from 'react';
import { Button, Card, Row, Col, Spin } from 'antd';

const PageContainer = ({
  title,
  visible,
  children,
  readOnly = false,
  maskClosable = true,
  onOkClick,
  onBackClick,
  okButtonText = 'Confirmar',
  backButtonText = 'Voltar',
  loading,
  saving,
  className = '',
  toolbarComponent: ToolbarComponent,
  size,
  ...rest
}) => {
  const width =
    size && (size.includes('%') || size.includes('px')) ? size : undefined;
  const sizeClass = size && !width ? size : null;

  return (
    <div className="gx-container-app">
      <Card className="gx-card ">
        <div className="gx-page-heading-title">{title}</div>
        {children}
        <div className="gx-d-flex gx-justify-content-end gx-mr-3">
          {ToolbarComponent ? (
            <ToolbarComponent
              {...rest}
              onOkClick={onOkClick}
              okButtonText={okButtonText}
              onBackClick={onBackClick}
              backButtonText={backButtonText}
              loading={loading}
              saving={saving}
            />
          ) : (
            <div>
              {readOnly ? (
                <Button onClick={onBackClick} style={{ marginRight: 8 }}>
                  {backButtonText}
                </Button>
              ) : (
                <>
                  <Button onClick={onBackClick} style={{ marginRight: 8 }}>
                    {backButtonText}
                  </Button>
                  <Button onClick={onOkClick} type="primary" loading={saving}>
                    {okButtonText}
                  </Button>
                </>
              )}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default PageContainer;
